import { styled } from '@mui/material';

export const OlStyled = styled('ol')({
  fontSize: '14px',
  paddingLeft: '20px',
  margin: '8px 0',
});

export const LiStyled = styled('li')({
  fontSize: '14px',
  fontWeight: '400',
  marginBottom: '4px',
});
